import type { Indicator } from '../indicator';
import type { HTMLAttributes, ReactElement } from 'react';

import React from 'react';

import { classNames } from '../../../utils/class-names';

import styles from './progress-list.module.css';

export type ProgressListProps = {
  isNarrow?: boolean;
  children?: ReactElement<Indicator> | ReactElement<Indicator>[];
} & HTMLAttributes<HTMLDivElement>;

export function ProgressList({ children, className, isNarrow, ...props }: ProgressListProps) {
  if (!children) return null;

  return (
    <div {...props} className={classNames(styles.container, className, isNarrow && styles.isNarrow)}>
      {children}
    </div>
  );
}
